(function () {
  'use strict';

  var module = angular.module('uwAgenda.global');
  module.controller('HeaderController', [
    '$rootScope',
    '$scope',
    '$state',
    '$localStorage',
    'SharedAgendaService',
    'UserService',
    'AuthenticationService',
    'AdministrationService',
    'SharedAgendaBroadcast',
    'AppointmentDetailService',
    'ExternalPatientBroadcast',
    'Alert',
    '$translate',
    'AgendaTransitionService',
    'TranscriptionService',
    HeaderControllerFn,
  ]);

  /* Header Controller */
  function HeaderControllerFn(
    $rootScope,
    $scope,
    $state,
    $localStorage,
    SharedAgendaService,
    UserService,
    AuthenticationService,
    AdministrationService,
    SharedAgendaBroadcast,
    AppointmentDetailService,
    ExternalPatientBroadcast,
    Alert,
    $translate,
    AgendaTransitionService,
    TranscriptionService,
  ) {
    var vm = this;

    // init metronic header
    Layout.initHeader();

    vm.firstName = null;
    vm.userId = null;

    var activeHttpRequestsListener = null;
    var agendaChangedListener = null;
    var externalPatientBroadcastListener = null;

    activate();

    // activate
    function activate() {
      // current firstName
      vm.firstName = SharedAgendaService.getLoggedInUserData().firstName;
      // current user
      vm.userId = SharedAgendaService.currentUser().id;
      // logged in user
      vm.loggedInUserId = SharedAgendaService.getLoggedInUserData().id;
      //current group practice 
      vm.currentGroupPracticeId = SharedAgendaService.data.currentAgenda.owner.groupPracticeId;

      activeHttpRequestsListener = $rootScope.$on(
        'ActiveHttpRequests',
        function (even, args) {
          vm.showProgress = args.activeRequests > 0;
        }
      );      

      setCurrentAgendaNameAndPossibleLanguageWarning();
      showDropDownOptions();
      UserService.getExternalPatientSearchResult(vm.userId);

      agendaChangedListener = $scope.$on(SharedAgendaBroadcast.AgendaOwnerChanged, function () {
        vm.userId = SharedAgendaService.currentUser().id;
        setCurrentAgendaNameAndPossibleLanguageWarning();
        showDropDownOptions();

        // check if we're moving to a different group practice
        const agendaChangedToGroupPracticeId = SharedAgendaService.data.currentAgenda.owner.groupPracticeId;
        if (vm.currentGroupPracticeId && vm.currentGroupPracticeId !== agendaChangedToGroupPracticeId) {
          UserService.clearExternalPatient();
          vm.externalPatientCaption = null;
          vm.externalPatientResults = 0;
          TranscriptionService.clearTranscript();
        }
        vm.currentGroupPracticeId = agendaChangedToGroupPracticeId; //store for next time
      });
      
      externalPatientBroadcastListener = $scope.$on(ExternalPatientBroadcast.clear, function() {
        vm.externalPatientCaption = null;
        vm.externalPatientResults = 0;
        TranscriptionService.clearTranscript();
      });

      externalPatientBroadcastListener = $scope.$on(ExternalPatientBroadcast.set, function() {
        let externalResults = $localStorage.ExternalPatientSearchResult;
        if (!externalResults)
        {
          vm.externalPatientResults = 0;
          // external results were not loaded yet so please load
          UserService.getExternalPatientSearchResult(vm.userId);
        }else{
          vm.externalPatientCaption = UserService.getExternalPatientCaption(externalResults, SharedAgendaService.data.currentAgenda.allowPhoneNumberRecognition);
          vm.externalPatientResults = externalResults.length;
        }
      });
      
      vm.foundTranscript = () => TranscriptionService.hasFoundTranscript();
      vm.reopenTranscript = () => TranscriptionService.reopenTranscript();
      
    } // activate

    function setCurrentAgendaNameAndPossibleLanguageWarning() {
      let owner = SharedAgendaService.currentUser();      
      vm.currentAgendaName = owner.company || owner.caption;
      vm.currentAgendaOwnerId = owner.id;
      
      vm.currentAgendaIsSuperAdmin = SharedAgendaService.currentAgendaIsSuperAdmin();
      vm.currentPracticeIsRingphoneHq = SharedAgendaService.currentPracticeIsRingphoneHq();

      if (owner.languageId !== $localStorage.CurrentLanguage.id) {
        vm.showLanguageWarning = true;
        vm.LanguageIdOfAgenda = owner.languageId;
      }
      else{
        vm.showLanguageWarning = false;
      }
    }

    function showDropDownOptions() {
      let owner = SharedAgendaService.currentUser();
      vm.currentAgendaOwnerId = owner.id;
      vm.isSuperadminAgenda = SharedAgendaService.currentAgendaIsSuperAdmin();
    }

    vm.logout = function () {
      // log out (clean)
      AuthenticationService.logout();
      // manual log out
      AuthenticationService.ManualLogOut = true;
      // go to login, but do not login automatic
      $state.go('Login');
    };
    
    vm.clearActiveSettingsTab = function (){
      $localStorage.activeSettingsTab = "" ;
    }

    vm.clearExternalPatient = function() {
      const confirmation = $translate.instant('external_patient_cleared', { name: vm.externalPatientCaption});
      Alert.info(confirmation);

      UserService.clearExternalPatient();
      TranscriptionService.clearTranscript();
    }
    
    vm.backToAdminPage = () => {
      let superAdminId = SharedAgendaService.getSuperAdminId();
      AgendaTransitionService.toContacts(superAdminId);
    };
    
    vm.backToHqPage = () => {
      let ringphoneHqId = SharedAgendaService.getRingphoneHqId();
      AgendaTransitionService.change(ringphoneHqId, undefined, undefined);
    };

    $scope.$on('$destroy', function () {
      if (activeHttpRequestsListener) {       
        activeHttpRequestsListener();
      }
      if (agendaChangedListener) {
        agendaChangedListener();
      }
      if (externalPatientBroadcastListener) {
        externalPatientBroadcastListener();
      }
    });
  }
})();
